import React, { useContext } from "react";
import PropTypes from "prop-types";
import { SchemaContext } from "../container";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Box } from "@flexisaf/flexibull2";
import styled from "styled-components";
import { InputWrapper, InputError } from "../input-wrapper";

const FieldStack = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0;
  padding: 0;
`;

const FieldLabel = styled.label`
  display: block;
  position: static;
  margin: 0 0 0.4rem;
  padding: 0;
  font-size: 0.78rem;
  font-weight: 500;
  letter-spacing: 0;
  text-transform: none;
  color: #5a5368;
  line-height: 1.35;
`;

const Phone = (props) => {
  const { disabledFields, errorFields, fieldValue, updateFieldValue } =
    useContext(SchemaContext);

  const Re = (value) => {
    if (disabledFields.includes(props.keyField)) return;
    updateFieldValue(props.keyField, value);
  };

  return (
    <FieldStack>
      <InputWrapper {...props}>
        {props?.props?.label ? (
          <FieldLabel>
            {props.props.label}{" "}
            {props.props?.required ? (
              <span style={{ color: "red" }}>*</span>
            ) : null}
          </FieldLabel>
        ) : null}
        <ReactPhoneInput
          inputExtraProps={{
            ...props.props,
          }}
          containerStyle={{
            width: "100%",
          }}
          inputStyle={{
            width: "100%",
            height: "42px",
            border: "1px solid #D8D8E3",
            borderRadius: "8px",
          }}
          country={"ng"}
          enableAreaCodes={false}
          name={props.keyField}
          value={fieldValue?.[props.keyField]?.toString()}
          onChange={Re}
          inputProps={{
            required: props?.props?.required,
          }}
          disabled={disabledFields.includes(props.keyField)}
        />
        <InputError>{errorFields[props.keyField]}</InputError>
      </InputWrapper>
    </FieldStack>
  );
};

Phone.defaultProps = {
  label: null,
  placeholder: "enter value",
  helper: null,
  type: "text",
  rules: {
    validation: null,
    required: false,
    before: null,
  },
};

Phone.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  helper: PropTypes.string,
  type: PropTypes.string,
  rules: PropTypes.any,
};

export default Phone;
